export const numberCompareAscFn = (num1: number, num2: number): number => {
    if (num1 > num2) {
        return 1;
    } else if (num1 < num2) {
        return -1;
    } else {
        return 0;
    }
};
